// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hA7ce","controls":"styles_controls__2e83U","charLimit":"styles_charLimit__1M4Qo","input":"styles_input__28iFO","send":"styles_send__1xtMY"};